import { HTTPClient } from '@rjgf/http-client'
import { SwaggerApi } from './swagger'
import { SwaggerApi as SwaggerMixAuthApi } from './swagger-mix-auth'
import { SwaggerApi as ExpertApi } from './expert-swagger'
import { SwaggerApi as ExamApi } from './swagger-exam'
import config from '@/config'
import { useUserStore } from '@/store/user'
import { useMixAuthStore } from '@/store/mix-auth'
import pinia from '@/store'
import router from '@/router'
import { HALL_ACTIVE_RULE } from '../../../../micro/micro-config'
import { GlobalActions } from '../../../../enums/globa'
import Vue from 'vue'
import { getFileDownloadToken, clearFileDownloadToken } from '../utils/file-token'

const client = new HTTPClient(config.get('SERVER_URL'))
const mixAuthApiClient = new HTTPClient(config.get('MIX_AUTH_SERVER_URL'))
const expertClient = new HTTPClient(config.get('SERVER_URL'))
const examClient = new HTTPClient(config.get('EXAM_SERVER_URL'))

client.client.interceptors.request.use(
  (requestConfig) => {
    requestConfig.headers['Qwert'] = '6yyrYfcPi28LuzpH'
    return requestConfig
  },
  (error) => {
    return Promise.reject(error)
  },
)

// 文件下载 Token 过期自动刷新重试
client.client.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error?.response?.status === 401 && (error.config?.url || '').includes('/api/file/download')) {
      // 同一请求仅允许刷新 Token 重试一次，防止后端持续 401 时无限重试
      if (error.config.__fileTokenRetried) {
        return Promise.reject(error)
      }
      error.config.__fileTokenRetried = true
      try {
        clearFileDownloadToken()
        const newToken = await getFileDownloadToken()
        const oldUrl = error.config.url || ''
        const hasToken = /([?&])token=[^&]+/.test(oldUrl)
        error.config.url = hasToken
          ? oldUrl.replace(/([?&])token=[^&]+/, `$1token=${newToken}`)
          : oldUrl + (oldUrl.includes('?') ? '&' : '?') + `token=${newToken}`
        return client.client.request(error.config)
      } catch (e) {
        return Promise.reject(e)
      }
    }
    return Promise.reject(error)
  },
)

const handlerAPIError = (err: Error) => {
  console.error(err.message)
}
client.on('error', handlerAPIError)
mixAuthApiClient.on('error', handlerAPIError)
expertClient.on('error', handlerAPIError)
examClient.on('error', handlerAPIError)

const handlerUnauthorize = () => {
  console.log('main-micro: unauthorize')
  const userStore = useUserStore(pinia)
  userStore.logout()
  const mixAuthStore = useMixAuthStore(pinia)
  mixAuthStore.clear()
  if (window.__POWERED_BY_QIANKUN__) {
    Vue.prototype.$setGlobalState({
      action: GlobalActions.SignOut,
      userInfo: {},
      token: '',
    })
  }
  if (router.currentRoute.path !== HALL_ACTIVE_RULE) {
    window.location.href = location.origin + '/hall'
  }
}
client.on('unauthorize', handlerUnauthorize)
mixAuthApiClient.on('unauthorize', handlerUnauthorize)
expertClient.on('unauthorize', handlerUnauthorize)
examClient.on('unauthorize', handlerUnauthorize)

const api = client as unknown as SwaggerApi
const mixAuthApi = mixAuthApiClient as unknown as SwaggerMixAuthApi
const expertApi = expertClient as unknown as ExpertApi
const examApi = examClient as unknown as ExamApi

export { api, mixAuthApi, expertApi, examApi }
